import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './Layout/index';
import PagaTuCuenta from './PagaTuCuenta';
import Home from './Home';
import Registro from './Usuario/Registro';
import Recuperar from './Usuario/Recuperar';
import Reenviar from './Usuario/Reenviar';
import Usuario from './Usuario/Usuario';
import Administra from './Administra';
import Detalle from './DetalleCuenta';
import Documentos from './DetalleCuenta/Documentos';
import Correo from './DetalleCuenta/Correo';
import Pagos from './DetalleCuenta/Pagos';
import Consumos from './DetalleCuenta/Consumos';
import OrdenDeCompra from './Home/OrdenDeCompra';
import Suscripcion from './Home/Suscripcion';
import Error from './Home/Error';
import ErrorBoundary from './components/ErrorBoundary';
import IngresaLectura from './IngresaLectura/Index';
import IngresaRequerimiento from './IngresaRequerimiento/Index';
import SuscripcionPAC from './SuscripcionPAC/Index';
import ScrollToTop from './ScrollToTop'
import Convenios from './DetalleCuenta/Convenios'; 
import Requerimientos from './DetalleCuenta/Requerimientos';
import Suscripciones from './DetalleCuenta/Suscripciones';
import Cartas from './DetalleCuenta/Cartas';

import 'react-toggle/style.css'
import './custom.css'
import 'react-select/dist/react-select.css';

var Global = {};

export { Global };

export default class App extends Component {
  constructor(props) {
    super()
    const urlCdn = (props.portal && props.portal.UrlCdn) || 'https://recaudador.asyntec.com';
    Global = {
      FormatearNumero(x) {
        return (x||0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      DV: function (T) {
        var M = 0, S = 1;
        for (; T; T = Math.floor(T / 10))
          S = (S + T % 10 * (9 - M++ % 6)) % 11;
        return S ? S - 1 : 'k';
      },
      AgregaDV: function (rut) {
        if (rut != null) {
          rut = rut.toString().split('-')[0].replace(/[.]/g, '');
          return rut + "-" + Global.DV(rut);
        } else {
          return "";
        }
      },
      ValidaRUT: function (rutCompleto) {
        if (!/^[0-9.]+-[0-9kK]{1}$/.test(rutCompleto))
          return false;
        var tmp = rutCompleto.split('-');
        var digv = tmp[1];
        var rut = tmp[0].replace(/[.]/g, '');
        if (digv == 'K') digv = 'k';
        return (Global.DV(rut) == digv);
      },
      ValidateEmail: function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      },
      toTitleCase(str) {
        return str && str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
      },
      logosRecaudadores: {
        transbank: 'https://cdn.smartx.cl/images/logo-webpay-plus.png',
        flow: `${urlCdn}/logoflow.png`,
        khipu: 'https://s3.amazonaws.com/static.khipu.com/buttons/2015/110x50-transparent.png',
        mach: `${urlCdn}/logomach.png`,
        bci: `${urlCdn}/logobci.png`,
        servipag: 'https://cdn.smartx.cl/images/logo-servipag.png',
        unired: `${urlCdn}/unired.jpg`,
        patpass: `${urlCdn}/patpass.jpg`
      },
      Servicios: [],
      cargandoServicios: false,
      Empresas: [],
      isAnonBlocked(empresaKey) {
        const siteBlocked = Global.otros?.BloqueaConsultaAnonima === true || 
                            Global.otros?.BloqueaConsultaAnonima === "1" || 
                            Global.otros?.BloqueaConsultaAnonima === "true";
        if (siteBlocked) return true;

        if (empresaKey) {
          const emp = Global.empresas.find(e => e.key === empresaKey);
          return emp?.otros?.BloqueaConsultaAnonima === true || 
                 emp?.otros?.BloqueaConsultaAnonima === "1" || 
                 emp?.otros?.BloqueaConsultaAnonima === "true";
        }

        if (Global.empresas && Global.empresas.length > 0) {
          return Global.empresas.every(e => 
            e.otros?.BloqueaConsultaAnonima === true || 
            e.otros?.BloqueaConsultaAnonima === "1" || 
            e.otros?.BloqueaConsultaAnonima === "true"
          );
        }
        return false;
      },
      ...props.portal,
      modo: (props.portal && (props.portal.Modo || props.portal.modo)) || "",
      vista: (props.portal && (props.portal.Vista || props.portal.vista)) || "login",
      urlDestino: (props.portal && (props.portal.UrlDestino || props.portal.urlDestino)) || "",
      isModoCompact() {
        return Global.modo === "compact" || Global.modo === "compacto";
      },
      apiKeyCaptcha: (props.portal && (props.portal.apiKeyCaptcha || props.portal.ApiKeyCaptcha)) || '',
      ApiKeyCaptcha: (props.portal && (props.portal.apiKeyCaptcha || props.portal.ApiKeyCaptcha)) || '',
      politicaPassword: (props.portal && (props.portal.politicaPassword || props.portal.PoliticaPassword)) || {
        largoMinimo: 10,
        requiereMayuscula: false,
        requiereMinuscula: false,
        requiereDigito: false,
        requiereNoAlfanumerico: false
      },
      getLargoMinimoPassword() {
        const pol = Global.politicaPassword;
        const val = pol && (pol.largoMinimo || pol.LargoMinimo);
        return typeof val === 'number' && val >= 6 ? val : 10;
      },
      validarPoliticaPassword(password) {
        const pass = password || "";
        const pol = Global.politicaPassword || {};
        const minLargo = Global.getLargoMinimoPassword();
        const errores = [];

        if (pass.length < minLargo) {
          errores.push(`La contraseña debe tener al menos ${minLargo} caracteres`);
        }
        if ((pol.requiereMayuscula || pol.RequiereMayuscula) && !/[A-Z]/.test(pass)) {
          errores.push("La contraseña debe incluir al menos una letra mayúscula");
        }
        if ((pol.requiereMinuscula || pol.RequiereMinuscula) && !/[a-z]/.test(pass)) {
          errores.push("La contraseña debe incluir al menos una letra minúscula");
        }
        if ((pol.requiereDigito || pol.RequiereDigito) && !/[0-9]/.test(pass)) {
          errores.push("La contraseña debe incluir al menos un número");
        }
        if ((pol.requiereNoAlfanumerico || pol.RequiereNoAlfanumerico) && !/[^a-zA-Z0-9]/.test(pass)) {
          errores.push("La contraseña debe incluir al menos un carácter especial");
        }

        return {
          esValida: errores.length === 0,
          errores: errores,
          mensajePrincipal: errores.length > 0 ? errores[0] : ""
        };
      }
    }
  }
  static displayName = App.name;

  render() {
    return (
      <ScrollToTop>
        <Layout>
          <MyRoute exact path='/' Component={Home} />
          <MyRoute exact path='/lectura' Component={IngresaLectura} />
          <MyRoute exact path='/requerimientos' Component={IngresaRequerimiento} />
          {Global.otros && Global.otros.SuscripcionAnonima && Global.empresas.some(e => e.otros && e.otros.Suscripciones && Object.keys(e.otros.Suscripciones).length > 0) &&
            <MyRoute exact path='/suscripcion' Component={SuscripcionPAC} />
          }
          <MyRoute path='/ordendecompra/:guid' Component={OrdenDeCompra} />
          <MyRoute path='/suscripcion/resultado' Component={Suscripcion} />
          <MyRoute path='/suscripcion/:id' Component={Suscripcion} />
          <MyRoute path='/error/:error' Component={Error} />
          <MyRoute exact path='/paga' Component={PagaTuCuenta} />
          <MyRoute path='/sucursal' Component={Administra} />
          <MyRoute path='/detalle' Component={Detalle}>
            <MyRoute path='/' exact Component={Documentos} />
            <MyRoute path='/documentos' exact Component={Documentos} />
            <MyRoute path='/pagos' exact Component={Pagos} />
            <MyRoute path='/consumos' exact Component={Consumos} />
            <MyRoute path='/email' exact Component={Correo} />
            <MyRoute path='/convenios' exact Component={Convenios} />
            <MyRoute path='/requerimientos' exact Component={Requerimientos} />
            <MyRoute path='/suscripciones' exact Component={Suscripciones} />
            <MyRoute path='/cartas' exact Component={Cartas} />
          </MyRoute>
          <MyRoute path='/registrate' Component={Registro} />
          <MyRoute path='/recuperar' Component={Recuperar} />
          <MyRoute path='/reenviar' Component={Reenviar} />
          <MyRoute path='/usuario' Component={Usuario} />
          <MyRoute Component={Home} />
        </Layout>
      </ScrollToTop>
    );
  }
}

class MyRoute extends React.Component {
  render() {
    var { Component, path, exact, passedProps } = this.props;
    return (
      <ErrorBoundary>
        <Route
          path={path}
          exact={exact}
          render={props => <Component {...passedProps}>
            {
              React.Children.map(this.props.children, child => {
                return React.cloneElement(child, { path: props.match.url + (child.props.path || ""), passedProps }) // para forzar la actualización
              }
              )
            }
          </Component>}
        />
      </ErrorBoundary>
    );
  }
}